<template>
  <img style="width: 1.1em; height: 1.1em;" :src="checked ? filterIconEd : filterIcon" alt="" />
</template>

<script>
import filterIcon from '@/assets/icons/icon_zt.png'
import filterIconEd from '@/assets/icons/icon_zt_x.png'
export default {
  name: 'PtFilterIcon',
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterIcon,
      filterIconEd
    }
  }
}
</script>
